var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-wrapper",class:_vm.serviceClass},[_c('iframe',{attrs:{"id":"player","type":"text/html","src":_vm.videoSrc,"frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }